export default __webpack_public_path__ + "static/media/kioskBGI.7027d30d.png";